import { render, staticRenderFns } from "./PlanUpgradeModal.vue?vue&type=template&id=72a08904&scoped=true&"
import script from "./PlanUpgradeModal.vue?vue&type=script&lang=ts&"
export * from "./PlanUpgradeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlanUpgradeModal.vue?vue&type=style&index=0&id=72a08904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a08904",
  null
  
)

export default component.exports